import { default as pino } from 'pino'

const isTestingWithJest = process.env.JEST_WORKER_ID !== undefined
const isProd = process.env.STAGE === 'prod'

export const logger = pino({
  name: 'PowerPoker',
  level: isTestingWithJest || isProd ? 'silent' : 'error'
})
